export function splitSearchKeyword(keyword: string, delimiter = ' '): string[] {
    return keyword
      .split(delimiter)
      .filter((word) => !!word)
      .map((keyword) => keyword.toLowerCase());
  }